'use strict';

var base = require('./base');
var focusHelper = require('base/components/focus');
var recurringPurchase = require('./../components/recurringPurchase');

/**
 * Handles recurring purchase checkbox toggle. Checks user login status and redirects
 * to login page if needed.
 * @param {HTMLElement} checkbox - The recurring purchase checkbox element
 * @returns {void}
 */
function handleRecurringPurchaseToggle(checkbox) {
    var $checkbox = $(checkbox);
    var redirectUrl = $checkbox.data('redirect');
    var isCustomerLogged = $('.ua-customer-logged').length > 0  || $('#myaccount .user-message .user-name').length > 0;
    var $modal = $('#quickViewModal');
    var $addToCartBtn = $modal.find('.product-actions .btn.btn-primary');
    var $selectContainer = $modal.find('.recurring-purchase .select-container');
    var $buttonTextElement = $modal.find('.add-to-cart-desktop');
    var $quantitySelector = $modal.find('.quantity-form.quantity-selector');
    var $recurrencyLoginMessage = $modal.find('.recurrency-login-message');

    if (isCustomerLogged) {
        if ($checkbox.prop('checked')) {
            // Store original button text if not already stored
            if (!$addToCartBtn.data('original-text')) {
                $addToCartBtn.data('original-text', $buttonTextElement.text());
            }

            $buttonTextElement.text($addToCartBtn.data('recurrency-text'));
            $selectContainer.removeClass('d-none');
            recurringPurchase.useAsRecurrencePurchaseTrigger($buttonTextElement,true);
        } else {
            $buttonTextElement.text($addToCartBtn.data('original-text'));
            $selectContainer.addClass('d-none');
            $addToCartBtn.prop('disabled', false);
            recurringPurchase.useAsRecurrencePurchaseTrigger($buttonTextElement,false);
        }
    } else if ($checkbox.prop('checked')) {
        // Store original button text if not already stored
        if (!$addToCartBtn.attr('data-original-text')) {
            $addToCartBtn.attr('data-original-text', $buttonTextElement.text());
        }

        $buttonTextElement.text('Iniciar sesión');
        $quantitySelector.addClass('d-none');
        $recurrencyLoginMessage.removeClass('d-none');

        // Update button click handler
        $addToCartBtn.removeClass('add-to-cart');
        $addToCartBtn.off('click').on('click', function(e) {
            e.preventDefault();
            window.location.href = redirectUrl;
        });
    } else {
        // Reset everything back to original state
        $quantitySelector.removeClass('d-none');
        $recurrencyLoginMessage.addClass('d-none');

        $addToCartBtn.addClass('add-to-cart');
        // Force the button to reattach its original event handlers
        $addToCartBtn.off('click');
        // Now restore the text
        $buttonTextElement.text($addToCartBtn.attr('data-original-text'));
    }
}

function initThumbnailCarousel($modal) {
    $modal.find('.product-thumbnails .product-thumbnail').on('click', function(e) {
        e.preventDefault();
        const slideIndex = $(this).data('slide-to');

        $modal.find('.product-thumbnails .product-thumbnail').removeClass('active');
        $(this).addClass('active');

        $modal.find('.carousel').carousel(slideIndex);
    });

    $modal.find('.carousel').on('slid.bs.carousel', function(e) {
        const slideIndex = $(e.relatedTarget).index();

        $modal.find('.product-thumbnails .product-thumbnail').removeClass('active');
        $modal.find(`.product-thumbnails .product-thumbnail[data-slide-to="${slideIndex}"]`).addClass('active');
    });
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog modal-dialog-centered">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Initializes the controlled product modal interactions for quickview
 * Sets up event listeners for showing/hiding the child modal
 */
function initControlledProductModal() {
    var $quickView = $('#quickViewModal');

    // Show child modal
    $quickView.on('click', '.show-child-modal', function(e) {
        e.preventDefault();
        var $controlledProduct = $(this).closest('.controlled-product-modal-container');
        var $childModal = $controlledProduct.find('.modal').first();
        $childModal.addClass('show child-modal');
    });

    // Close child modal
    $quickView.on('click', '.close-child-modal', function(e) {
        e.preventDefault();
        var $controlledProduct = $(this).closest('.controlled-product-modal-container');
        var $childModal = $controlledProduct.find('.modal').first();
        $childModal.removeClass('show child-modal');
    });
    $quickView.on('click','.recurring-purchase-open-delivery-modal', function(event) {
        event.preventDefault();
        var redirectLink = $('#quickViewModal').find('.full-pdp-link').attr('href');
        $('.pdp-redirect-url').val(redirectLink+'?selectRecurrentToggle=true');
        // close quick view model and open delivery model to select location
        $('#quickViewModal').modal('hide');
        $(document).trigger("openDeliveryModalRequest", { redirectUrl: '' });
    });
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        cache: false,
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');


            initThumbnailCarousel($('#quickViewModal'));
            initControlledProductModal();

            $.spinner().stop();
            recurringPurchase.manageIncompatibleDeliveryMethodUI();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);

            $('body').on('change', '.recurring-purchase-checkbox', function () {
                handleRecurringPurchaseToggle(this)
            });
            recurringPurchase.handleRecurringPurchaseButtonClicked(base);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr(
                'disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
};
